import React from "react";
import googleLogo from "../../Assets/Images/Google.png";
import atlassianLogo from "../../Assets/Images/Atlassian.png";
import canonLogo from "../../Assets/Images/Canon.png";
import walmartLogo from "../../Assets/Images/Walmart.png";
import amazonLogo from "../../Assets/Images/Amazon.png";

export const TrustedClients = () => {
  const logos = [googleLogo, atlassianLogo, canonLogo, walmartLogo, amazonLogo,googleLogo, atlassianLogo, canonLogo, walmartLogo, amazonLogo];

  return (
    <div className="trusted-container container">
      <span className="trusted-text">Trusted by the best in the world</span>
      <div className="logo-slider">
        <div className="logo-track">
          {logos.map((logo, index) => (
            <div className="logo-slide" key={index}>
              <img src={logo} alt="logo" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
